import type { Topic } from "../../shared/model.ts";

export const TOPIC_TINT: Record<Topic, string> = {
  ai_agents: "bg-lilac",
  data_engineering: "bg-mint",
  analytics_bi: "bg-peach",
  governance: "bg-sky",
  platform: "bg-sand",
  business_impact: "bg-rose",
};

const PATHS: Record<Topic, React.ReactNode> = {
  ai_agents: (
    <>
      <path d="M11 3.5c.6 3.6 2.3 5.4 5.9 6-3.6.6-5.3 2.4-5.9 6-.6-3.6-2.3-5.4-5.9-6 3.6-.6 5.3-2.4 5.9-6Z" />
      <path d="M18 15.5c.3 1.6 1 2.3 2.5 2.5-1.5.3-2.2 1-2.5 2.5-.3-1.5-1-2.2-2.5-2.5 1.5-.2 2.2-.9 2.5-2.5Z" />
    </>
  ),
  data_engineering: (
    <>
      <circle cx="5" cy="7" r="2.2" />
      <circle cx="12" cy="17" r="2.2" />
      <circle cx="19" cy="7" r="2.2" />
      <path d="M6.3 8.8 10.7 15M13.3 15l4.4-6.2M7.2 7h9.6" />
    </>
  ),
  analytics_bi: <path d="M4 20h16M7 16.5V11M12 16.5V6.5M17 16.5v-3.5" />,
  governance: (
    <>
      <path d="M12 3.5 5 6.2v5.3c0 4.3 3 7.6 7 9 4-1.4 7-4.7 7-9V6.2l-7-2.7Z" />
      <path d="m9 12 2.2 2.2L15.2 10" />
    </>
  ),
  platform: (
    <>
      <path d="m12 4 8 4-8 4-8-4 8-4Z" />
      <path d="m4 12 8 4 8-4M4 16l8 4 8-4" />
    </>
  ),
  business_impact: (
    <>
      <path d="M4 17 9.5 11.5l3.5 3.5L20 8" />
      <path d="M15 8h5v5" />
    </>
  ),
};

export function TopicIcon({ topic, size = "md" }: { topic: Topic; size?: "sm" | "md" }) {
  const box = size === "sm" ? "size-8 rounded-lg" : "size-11 rounded-xl";
  const icon = size === "sm" ? "size-[18px]" : "size-6";
  return (
    <span aria-hidden="true" className={`${box} ${TOPIC_TINT[topic]} inline-grid shrink-0 place-items-center text-ink/80`}>
      <svg viewBox="0 0 24 24" className={icon} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        {PATHS[topic]}
      </svg>
    </span>
  );
}
